import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Button = ({
  children,
  onClick,
  to,
  type = 'button',
  variant = 'primary',
  size = 'md',
  disabled = false,
  fullWidth = false,
  className = '',
  icon = null,
  ...rest
}) => {
  // GitHub 风格按钮变体
  const variants = {
    primary: 'bg-[#1f883d] hover:bg-[#1a7f37] text-[#ffffff] border border-[#1f883d]',
    secondary: 'bg-[#f6f8fa] hover:bg-[#f3f4f6] text-[#1f2328] border border-[#d0d7de]',
    success: 'bg-[#1f883d] hover:bg-[#1a7f37] text-[#ffffff] border border-[#1f883d]',
    danger: 'bg-[#cf222e] hover:bg-[#a40e26] text-[#ffffff] border border-[#cf222e]',
    warning: 'bg-[#fff8c5] hover:bg-[#f5e37a] text-[#9a6700] border border-[#eae088]',
    info: 'bg-[#0969da] hover:bg-[#0860ca] text-[#ffffff] border border-[#0969da]',
    outline: 'border border-[#d0d7de] text-[#24292f] hover:bg-[#f6f8fa]',
    ghost: 'text-[#0969da] hover:bg-[#ddf4ff]'
  };

  // 按钮尺寸
  const sizes = {
    sm: 'py-1 px-3 text-sm',
    md: 'py-2 px-4 text-base',
    lg: 'py-3 px-6 text-lg'
  };

  // 基本样式
  const baseStyles = 'rounded-md font-medium transition-all duration-150 flex items-center justify-center gap-2 relative overflow-hidden';
  
  // 鼠标悬停效果
  const hoverEffect = !disabled && 'transform active:scale-[0.98]';
  
  // 禁用样式
  const disabledStyles = disabled && 'opacity-60 cursor-not-allowed';
  
  // 组合所有样式
  const buttonStyles = `${baseStyles} ${variants[variant]} ${sizes[size]} ${hoverEffect} ${disabledStyles} ${fullWidth ? 'w-full' : ''} ${className}`;

  const buttonContent = (
    <>
      {icon && <span className="inline-block">{icon}</span>}
      {children}
    </>
  );
  
  // 如果提供了to属性，渲染Link组件
  if (to) {
    return (
      <Link to={to} className={buttonStyles} {...rest}>
        {buttonContent}
      </Link>
    );
  }
  
  // 否则渲染按钮
  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={buttonStyles}
      whileTap={{ scale: disabled ? 1 : 0.98 }}
      {...rest}
    >
      {buttonContent}
    </motion.button>
  );
};

export default Button;
